module.exports = __webpack_public_path__ + "img/top.13609e27.jpg";